import CustomerVehicleHeaderContainer from './CustomerVehicleHeaderContainer';

export default CustomerVehicleHeaderContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/CustomerVehicleHeader/index.js